// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var PagesLogo = function PagesLogo(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M7.048 2.017l-.707 1.088h-3.78v9.79h3.154l-.19 1.088H2.017l-.544-.544V2.561l.544-.544zm3.427 0h3.508l.544.544v10.878l-.544.544H8.952l.707-1.088h3.78v-9.79h-3.154z",
      opacity: ".5"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M7.075 9.632H3.92l-.462-.843L9.115.086l.98.408-1.17 5.874h3.155l.462.843-5.657 8.703-.98-.408z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M3.35 4.274a.38.38 0 10-.381-.38.38.38 0 00.38.38zM4.356 4.274a.38.38 0 10-.381-.38.38.38 0 00.38.38zM5.362 4.274a.38.38 0 10-.38-.38.38.38 0 00.38.38z",
      opacity: ".5"
    }))
  );
};

export default PagesLogo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/PagesLogo.js
// module id = 1036
// module chunks = 0